import React from 'react';
import TOLogo from '../../../../static/images/TO/toyota-logo.svg'
import Row from 'react-bootstrap/Row'
import Image from 'react-bootstrap/Image'
import Button from 'react-bootstrap/Button'

import AppVars from '../../../../AppVars.js'

const appVars = AppVars.getInstance()

class JoinNowView extends React.Component{
    constructor(props){
        super(props);
        this.state ={

        }
    }

    render(){
        return (
            <div>
            <div className = "justify-content-center line-box">
                <div role = "banner">
                    <Row className = "">
                    <a href = {appVars.getAppHomeURL(this.props.style)}><Image className = "corner-logo absolute" alt = "Toyota" src={require('../../../../static/images/Toyota-Logo.svg').default} /></a>
                    </Row>
                </div>
                <div role = "main">
                    <Row className = "justify-content-center location">
                        <div>Sign In</div>
                    </Row>
                    <Row className = "title__TO left">Apple ID Email Hidden</Row>
                    <Row className = "justify-content-center text__TO">
                        In order to Sign In with Apple, you must share the email associated with your Apple ID. You can change your sharing settings at the <a style = {{"color": "#000000"}}href="https://appleid.apple.com">Apple ID website</a>
                    </Row>
                    <Row className = "justify-content-center text__TO">
                        Sign into your Apple ID account at the link above. Go the the <b>Security</b> section, then go to <b>Apps & Websites Using Apple ID.</b> Find <b>Toyota</b>, then select <b>Stop Using Apple ID.</b>
                    </Row>
                    <Row className = "justify-content-center text__TO">
                        Return to our sign-in screen and Sign in with Apple to share your Apple ID email address.
                    </Row>
                    <div>
                    <a href= "/"><Button data-testid = "TryAgainButton" bsPrefix = "float-left button__TO" type = "button" >Back to Sign In</Button></a>
                    </div>
                </div>
            </div>
          </div>
        )
  }
}

export default JoinNowView;